// Plugin personnalisé pour ajouter des classes heading_custom_* à la div principale
import { Plugin } from '@ckeditor/ckeditor5-core';
import { ViewModel } from '@ckeditor/ckeditor5-ui';
import { createDropdown, addListToDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import { Collection } from '@ckeditor/ckeditor5-utils';

export default class CustomHeadingSelector extends Plugin {
    static get pluginName() {
        return 'CustomHeadingSelector';
    }

    init() {
        const editor = this.editor;
        const t = editor.t;

        // Attendre que l'éditeur soit prêt
        editor.on('ready', () => {
            console.log('CustomHeadingSelector: Éditeur prêt');
        });

        // Register UI component
        editor.ui.componentFactory.add('customHeadingSelector', (locale) => {
            const dropdownView = createDropdown(locale);

            dropdownView.set({
                label: 'Styles de Titre',
                tooltip: true,
            });

            dropdownView.buttonView.set({
                label: 'Styles de Titre',
                tooltip: true,
                isOn: false,
                withText: true,
            });

            // Collection des éléments de la liste
            const items = new Collection();

            // Élément pour supprimer toutes les classes
            const normalItem = {
                type: 'button',
                model: new ViewModel({
                    label: 'Normal (aucun style)',
                    withText: true,
                })
            };
            normalItem.model.class = ''; // Ajouter la propriété class directement
            items.add(normalItem);

            // Éléments pour chaque style personnalisé
            const principalItem = {
                type: 'button',
                model: new ViewModel({
                    label: 'Décimale hiérarchique (arithmétique)',
                    withText: true,
                })
            };
            principalItem.model.class = 'heading_custom_1';
            items.add(principalItem);

            const secondaireItem = {
                type: 'button',
                model: new ViewModel({
                    label: 'Chiffres romains',
                    withText: true,
                })
            };
            secondaireItem.model.class = 'heading_custom_2';
            items.add(secondaireItem);

            const sousTitreItem = {
                type: 'button',
                model: new ViewModel({
                    label: 'Lettres (alphabétique)',
                    withText: true,
                })
            };
            sousTitreItem.model.class = 'heading_custom_3';
            items.add(sousTitreItem);

            const sectionItem = {
                type: 'button',
                model: new ViewModel({
                    label: 'Mixte hiérarchique (alphanumérique)',
                    withText: true,
                })
            };
            sectionItem.model.class = 'heading_custom_4';
            items.add(sectionItem);

            // Ajouter les éléments au dropdown
            addListToDropdown(dropdownView, items);

            // Gérer les clics sur les éléments
            dropdownView.on('execute', (evt) => {
                console.log('Execute event:', evt);
                console.log('Event source:', evt.source);
                console.log('Event source model:', evt.source?.model);
                
                let selectedClass = '';
                
                // Différentes façons d'accéder à la classe selon la structure de l'événement
                if (evt.source && evt.source.model && evt.source.model.class !== undefined) {
                    selectedClass = evt.source.model.class;
                } else if (evt.source && evt.source.class !== undefined) {
                    selectedClass = evt.source.class;
                } else if (evt.source && evt.source.model && evt.source.model.get) {
                    selectedClass = evt.source.model.get('class') || '';
                } else {
                    console.warn('CustomHeadingSelector: Impossible de récupérer la classe depuis l\'événement');
                    return;
                }
                
                console.log('Classe sélectionnée:', selectedClass);
                this._applyClassToEditor(selectedClass);
                dropdownView.isOpen = false;
            });

            return dropdownView;
        });
    }

    _applyClassToEditor(className) {
        const editor = this.editor;
        
        // Utiliser setTimeout pour s'assurer que le DOM est accessible
        setTimeout(() => {
            // Plusieurs méthodes pour trouver l'élément éditeur
            let editorElement = null;
            
            // Méthode 1: Via le DOM directement
            editorElement = document.querySelector('.ck-editor__editable[contenteditable="true"]');
            
            // Méthode 2: Via l'API CKEditor si la première échoue
            if (!editorElement) {
                try {
                    editorElement = editor.ui.getEditableElement();
                } catch (e) {
                    console.warn('CustomHeadingSelector: Méthode 2 échouée:', e);
                }
            }
            
            // Méthode 3: Recherche plus générale
            if (!editorElement) {
                editorElement = document.querySelector('.ck-editor__editable');
            }
            
            if (!editorElement) {
                console.error('CustomHeadingSelector: Impossible de trouver l\'élément éditeur');
                console.log('Éléments disponibles:', document.querySelectorAll('[class*="ck-editor"]'));
                return;
            }
            
            console.log('CustomHeadingSelector: Élément trouvé:', editorElement);
            
            // Supprimer toutes les classes heading_custom_* existantes
            const classesToRemove = Array.from(editorElement.classList).filter(cls => 
                cls.startsWith('heading_custom_')
            );
            
            classesToRemove.forEach(cls => {
                editorElement.classList.remove(cls);
            });
            
            // Ajouter la nouvelle classe si elle n'est pas vide
            if (className) {
                editorElement.classList.add(className);
                console.log('CustomHeadingSelector: Classe ajoutée:', className);
            } else {
                console.log('CustomHeadingSelector: Classes personnalisées supprimées');
            }
            
            console.log('CustomHeadingSelector: Classes actuelles:', editorElement.className);
            
            // Déclencher un événement pour notifier le changement
            editor.fire('customHeadingClassChanged', {
                className: className,
                element: editorElement
            });
            
        }, 100); // Petit délai pour s'assurer que l'élément est disponible
    }
}
